/**
 * FIDE federation codes for the team names Lichess puts in broadcast PGNs.
 *
 * Pulled from the 46th Olympiad round data, where the round API carries both a
 * player's `team` (the full name, which is all the PGN stream gives us) and
 * their `fed` (the three-letter code). Generated, so leave it alone and
 * re-derive it if a future event names a team differently.
 */

const TEAM_CODES: Record<string, string> = {
  "Afghanistan": "AFG",
  "Albania": "ALB",
  "Algeria": "ALG",
  "Andorra": "AND",
  "Antigua and Barbuda": "ANT",
  "Argentina": "ARG",
  "Armenia": "ARM",
  "Aruba": "ARU",
  "Australia": "AUS",
  "Austria": "AUT",
  "Azerbaijan": "AZE",
  "Bahamas": "BAH",
  "Bahrain": "BRN",
  "Bangladesh": "BAN",
  "Barbados": "BAR",
  "Belarus": "FID",
  "Belgium": "BEL",
  "Belize": "BIZ",
  "Bermuda": "BER",
  "Bhutan": "BHU",
  "Bolivia": "BOL",
  "Bosnia & Herzegovina": "BIH",
  "Botswana": "BOT",
  "Brazil": "BRA",
  "British Virgin Islands": "IVB",
  "Brunei Darussalam": "BRU",
  "Bulgaria": "BUL",
  "Burkina Faso": "BUR",
  "Burundi": "BDI",
  "Cambodia": "CAM",
  "Cameroon": "CMR",
  "Canada": "CAN",
  "Cape Verde": "CPV",
  "Cayman Islands": "CAY",
  "Chad": "CHA",
  "Chile": "CHI",
  "China": "CHN",
  "Chinese Taipei": "TPE",
  "Colombia": "COL",
  "Comoros Islands": "COM",
  "Costa Rica": "CRC",
  "Croatia": "CRO",
  "Cuba": "CUB",
  "Curacao": "CUR",
  "Cyprus": "CYP",
  "Czech Republic": "CZE",
  "Democratic Republic of the Congo": "COD",
  "Denmark": "DEN",
  "Djibouti": "DJI",
  "Dominica": "DMA",
  "Dominican Republic": "DOM",
  "Ecuador": "ECU",
  "Egypt": "EGY",
  "El Salvador": "ESA",
  "England": "ENG",
  "Equatorial Guinea": "GEQ",
  "Estonia": "EST",
  "Eswatini": "SWZ",
  "Ethiopia": "ETH",
  "Faroe Islands": "FAI",
  "Fiji": "FIJ",
  "Finland": "FIN",
  "France": "FRA",
  "Gabon": "GAB",
  "Gambia": "GAM",
  "Georgia": "GEO",
  "Germany": "GER",
  "Ghana": "GHA",
  "Greece": "GRE",
  "Greenland": "GRL",
  "Grenada": "GRN",
  "Guam": "GUM",
  "Guatemala": "GUA",
  "Guernsey": "GCI",
  "Guinea": "GUI",
  "Guyana": "GUY",
  "Haiti": "HAI",
  "Honduras": "HON",
  "Hong Kong, China": "HKG",
  "Hungary": "HUN",
  "Iceland": "ISL",
  "India": "IND",
  "Indonesia": "INA",
  "Iran": "IRI",
  "Iraq": "IRQ",
  "Ireland": "IRL",
  "Isle of Man": "IOM",
  "Israel": "ISR",
  "Italy": "ITA",
  "Jamaica": "JAM",
  "Japan": "JPN",
  "Jersey": "JCI",
  "Jordan": "JOR",
  "Kazakhstan": "KAZ",
  "Kenya": "KEN",
  "Kiribati": "KIR",
  "Kosovo *": "KOS",
  "Kuwait": "KUW",
  "Kyrgyzstan": "KGZ",
  "Laos": "LAO",
  "Latvia": "LAT",
  "Lebanon": "LBN",
  "Lesotho": "LES",
  "Liberia": "LBR",
  "Libya": "LBA",
  "Liechtenstein": "LIE",
  "Lithuania": "LTU",
  "Luxembourg": "LUX",
  "Macau, China": "MAC",
  "Madagascar": "MAD",
  "Malawi": "MAW",
  "Malaysia": "MAS",
  "Maldives": "MDV",
  "Mali": "MLI",
  "Malta": "MLT",
  "Mauritania": "MTN",
  "Mauritius": "MRI",
  "Mexico": "MEX",
  "Moldova": "MDA",
  "Monaco": "MNC",
  "Mongolia": "MGL",
  "Montenegro": "MNE",
  "Morocco": "MAR",
  "Mozambique": "MOZ",
  "Myanmar": "MYA",
  "Namibia": "NAM",
  "Nauru": "NRU",
  "Nepal": "NEP",
  "Netherlands": "NED",
  "New Caledonia": "NCL",
  "New Zealand": "NZL",
  "Nicaragua": "NCA",
  "Niger": "NIG",
  "Nigeria": "NGR",
  "North Macedonia": "MKD",
  "Norway": "NOR",
  "Oman": "OMA",
  "Pakistan": "PAK",
  "Palau": "PLW",
  "Palestine": "PLE",
  "Panama": "PAN",
  "Papua New Guinea": "PNG",
  "Paraguay": "PAR",
  "Peru": "PER",
  "Philippines": "PHI",
  "Poland": "POL",
  "Portugal": "POR",
  "Puerto Rico": "PUR",
  "Qatar": "QAT",
  "Romania": "ROU",
  "Saint Kitts and Nevis": "SKN",
  "Saint Lucia": "LCA",
  "Saint Vincent and the Grenadines": "VIN",
  "San Marino": "SMR",
  "Sao Tome and Principe": "STP",
  "Saudi Arabia": "KSA",
  "Scotland": "SCO",
  "Senegal": "SEN",
  "Serbia": "SRB",
  "Seychelles": "SEY",
  "Sierra Leone": "SLE",
  "Singapore": "SGP",
  "Slovakia": "SVK",
  "Slovenia": "SLO",
  "Solomon Islands": "SOL",
  "Somalia": "SOM",
  "South Africa": "RSA",
  "South Korea": "KOR",
  "South Sudan": "SSD",
  "Spain": "ESP",
  "Sri Lanka": "SRI",
  "Sudan": "SUD",
  "Suriname": "SUR",
  "Sweden": "SWE",
  "Switzerland": "SUI",
  "Syria": "SYR",
  "Tajikistan": "TJK",
  "Tanzania": "TAN",
  "Thailand": "THA",
  "Timor-Leste": "TLS",
  "Togo": "TOG",
  "Tonga": "TGA",
  "Trinidad and Tobago": "TTO",
  "Tunisia": "TUN",
  "Turkiye": "TUR",
  "Turkmenistan": "TKM",
  "US Virgin Islands": "ISV",
  "Uganda": "UGA",
  "Ukraine": "UKR",
  "United Arab Emirates": "UAE",
  "United States of America": "USA",
  "Uruguay": "URU",
  "Uzbekistan": "UZB",
  "Vanuatu": "VAN",
  "Venezuela": "VEN",
  "Vietnam": "VIE",
  "Wales": "WLS",
  "Yemen": "YEM",
  "Zambia": "ZAM",
  "Zimbabwe": "ZIM",
};

/** Host federations enter more than one team: "Uzbekistan 2" → "UZB 2". */
const SUFFIXED = /^(.*?)[\s-]+([2-9]|I{1,3}V?|VI{0,3})$/;

function lookup(name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return null;
  const direct = TEAM_CODES[trimmed];
  if (direct) return direct;
  const found = Object.keys(TEAM_CODES).find(
    (key) => key.toLowerCase() === trimmed.toLowerCase()
  );
  return found ? TEAM_CODES[found] : null;
}

/**
 * Three-letter code for a team name, e.g. "India" → "IND". Falls back to the
 * first three letters so an unknown team still renders something sane.
 */
export function teamCode(name: string): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return "";

  const direct = lookup(trimmed);
  if (direct) return direct;

  const suffixed = trimmed.match(SUFFIXED);
  if (suffixed) {
    const base = lookup(suffixed[1]);
    if (base) return `${base} ${suffixed[2]}`;
  }

  return trimmed.slice(0, 3).toUpperCase();
}
